import type { Link, UefatvEditorialContent } from '@shared-types/uefatv.types';
import { LinkType, MediaType } from '@shared-types/uefatv.types';

export const getLink = (c: UefatvEditorialContent, id?: string) => {
  if (c.type === MediaType.VOD) {
    return `/vod/${c.id}?bucketId=${id}${c.lastSeen && c.lastSeen !== 'empty' ? `&lastSeen=${c.lastSeen}` : ''}`;
  }
  if (c.type === MediaType.PLAYLIST) {
    return `/playlist/${c.id}`;
  }

  return `/${c.type.toLowerCase()}/${c.id}`;
};

export const normalizeText = (n: string) => n?.toLowerCase().replace(/[^\w]+/g, '');

export const isValidElement = (link: Link) =>
  [MediaType.PLAYLIST, MediaType.VOD].includes(link?.event?.type) || link?.type === LinkType.EXTERNALLINK;

export const isVisibleInViewport = (element: HTMLElement) => {
  if (!element) return;
  const rect = element.getBoundingClientRect();
  return rect.top >= -element.clientHeight * 0.7;
};
